import { omit } from 'lodash';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const insertSecondHandSuppliesOneMutation = gql`mutation insert_second_hand_supplies_one($second_hand_supplies: second_hand_supplies_insert_input!){
  insert_second_hand_supplies_one(object: $second_hand_supplies){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddSecondHandSupplyService {

  constructor(private apollo: Apollo) { }

  addSecondHandSupply(second_hand_supplies: any){
    return this.apollo.use('external').mutate({
      mutation: insertSecondHandSuppliesOneMutation,
      variables: {
        second_hand_supplies: omit(second_hand_supplies, ["id"])
      }
    }).pipe(pluck('data', 'insert_second_hand_supplies_one', 'id')).toPromise();
  }


}
